<template>
  <div>
    <AppHeader/>

    <article class="pr-section post">
      <div class="post__wrap">
        <ol class="pr-breadcrumbs">
          <li><router-link to="/">{{ $t('home') }}</router-link></li>
          <li><router-link :to="{ path: '/', hash: '#novosti' }">{{ $t('novosti') }}</router-link></li>
          <li aria-current="page">{{ post.title }}</li>
        </ol>

        <span class="pr-post-card__tag">{{ $t('novosti') }}</span>
        <h1 class="post__title">{{ post.title }}</h1>
        <div class="post__meta">
          <span v-if="post.date_diff"><v-icon small>mdi-calendar-blank-outline</v-icon> {{ post.date_diff }}</span>
          <span v-if="post.views"><v-icon small>mdi-eye-outline</v-icon> {{ post.views }} {{ $t('conf.views') }}</span>
        </div>

        <img v-if="cover" class="post__cover" :src="cover" :alt="post.title"/>

        <div class="pr-article" v-html="post.content"></div>

        <div v-if="lista_slika.length > 1" class="post__gallery">
          <button
              v-for="(image, imageIndex) in lista_slika"
              :key="imageIndex"
              type="button"
              class="post__thumb"
              :style="{ backgroundImage: 'url(' + image + ')' }"
              :aria-label="'Slika ' + (imageIndex + 1)"
              @click="index = imageIndex"
          ></button>
        </div>
        <LightGallery
            :images="lista_slika"
            :index="index"
            :disable-scroll="true"
            slide
            @close="index = null"
        />
      </div>
    </article>

    <section v-if="related.length" class="pr-section pr-section--white">
      <div class="pr-container">
        <h2 class="pr-title related__title">{{ $t('conf.related_news') }}</h2>
        <div class="related">
          <router-link v-for="item in related" :key="item.id" :to="'/novosti/' + item.alias" class="pr-post-card">
            <div class="pr-post-card__media">
              <img class="pr-post-card__img" :src="storage + item.image" :alt="item.title" loading="lazy"/>
            </div>
            <div class="pr-post-card__body">
              <span class="pr-post-card__tag">{{ $t('novosti') }}</span>
              <h3 class="pr-post-card__title">{{ item.title }}</h3>
            </div>
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios';
import { LightGallery } from 'vue-light-gallery';
import AppHeader from './AppHeader';
import { setPostMeta, resetPageMeta } from '@/plugins/pageMeta';

export default {
  name: "Novosti",
  components: {
    LightGallery,
    AppHeader,
  },
  data() {
    return {
      storage: 'https://web-admin.sum.ba/api/storage/',
      lista_slika: [],
      post: {},
      news: [],
      index: null,
      page: 1,
    };
  },
  computed: {
    cover() {
      return this.lista_slika[0] || null;
    },
    related() {
      return this.news.filter(item => item.alias !== this.$route.params.alias).slice(0, 3);
    },
  },
  watch: {
    '$route.params.alias'() {
      this.load();
    },
  },
  mounted() {
    this.load();
  },
  beforeDestroy() {
    resetPageMeta();
  },
  methods: {
    load() {
      window.scrollTo(0, 0);
      this.getPost();
      this.getNews();
    },
    getPost() {
      axios
          .post("https://web-admin.sum.ba/api/web/objava", {alias: this.$route.params.alias})
          .then(response => {
            this.post = response.data;
            this.lista_slika = (this.post.images || []).map(image => this.storage + image);
            setPostMeta(this.post, 'novosti', this.$route.params.alias, this.$i18n.locale);
          })
    },
    getNews() {
      const requestBody = {
        page: this.page,
        postsPerPage: 4,
        categories: ["PR Days"]
      };
      axios
          .post("https://web-admin.sum.ba/api/web/objave", requestBody)
          .then(response => {
            this.news = response.data;
          })
    },
  }
};
</script>

<style lang="scss" scoped>
.post__wrap {
  max-width: 820px;
  margin: 0 auto;
  padding: 0 24px;
}

.post__title {
  margin: 0 0 14px;
  font-size: clamp(1.8rem, 4vw, 2.8rem);
  font-weight: 700;
  line-height: 1.2;
  color: var(--pr-navy);
}

.post__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 28px;
  font-size: 14px;
  color: var(--pr-muted);

  .v-icon {
    color: inherit !important;
  }
}

.post__cover {
  display: block;
  width: 100%;
  max-height: 520px;
  margin-bottom: 32px;
  border-radius: var(--pr-radius);
  object-fit: cover;
}

.post__gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 10px;
  margin-top: 32px;
}

.post__thumb {
  aspect-ratio: 4 / 3;
  border-radius: 10px;
  background-size: cover;
  background-position: center;
  transition: opacity .2s ease;

  &:hover {
    opacity: .85;
  }
}

.related__title {
  margin-bottom: 28px;
  font-size: 2rem;
}

.related {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
}

@media (max-width: 960px) {
  .related {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 600px) {
  .post__wrap {
    padding: 0 16px;
  }
  .related {
    grid-template-columns: 1fr;
  }
}
</style>
